import { useNavigate } from "react-router-dom";
import { Lightbulb, Glasses, Smartphone } from "lucide-react";
import { Layout } from "../../Components/layout";
import { Button, Col, Row } from "react-bootstrap";

import "./styles.css";

const instructions = [
  {
    icon: <Lightbulb />,
    emoji: "💡",
    title: "Iluminação",
    desc: "Procure um lugar bem claro, de preferência luz natural.",
  },
  {
    icon: <Glasses />,
    emoji: "🕶️",
    title: "Rosto Limpo",
    desc: "Retire óculos de sol, boné, máscara ou acessórios.",
  },
  {
    icon: <Smartphone />,
    emoji: "📱",
    title: "Posicionamento",
    desc: "Mantenha o celular na altura dos olhos e fique imóvel.",
  },
];

export function BiometriaInstrucoes() {
  const navigate = useNavigate();

  return (
    <Layout>
      <Row className="d-flex flex-column">
        <Col className="text-center mb-8">
          <h1 className="title">Quase lá!</h1>
          <p className="text-muted small mt-2">
            Siga as dicas para uma captura rápida e sem erros.
          </p>
        </Col>

        <Col className="d-flex flex-column gap-4 mb-4">
          {instructions.map((item) => (
            <div key={item.title} className="instruction_card">
              <div className="instruction_emoji border card_info">
                {item.emoji}
              </div>
              <div>
                <p className="info_title">{item.title}</p>
                <p className="info_text">{item.desc}</p>
              </div>
            </div>
          ))}
        </Col>

        <Col className="d-flex flex-column gap-3">
          <Button
            onClick={() => {
              navigate("/biometria/captura");
            }}
            className="py-2 d-flex align-items-center justify-content-center gap-2"
            size="lg"
          >
            Estou pronto para a foto
          </Button>
          <Button
            onClick={() => navigate(-1)}
            className="py-2 d-flex align-items-center justify-content-center gap-2"
            size="lg"
            variant="danger"
          >
            Voltar
          </Button>
        </Col>
      </Row>
    </Layout>
  );
}
